
































import { Component, Prop, Vue } from 'vue-property-decorator';

import ArrowIcon from '@/components/icons/ArrowBack.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LockIcon from '@/components/icons/Lock.vue';
import { getMenuIconName } from '@/utils/iconHelper';

@Component({
  components: {
    ArrowIcon,
    Typography,
    LockIcon
  }
})
export default class FeatureCard extends Vue {
  @Prop() data!: any;

  getMenuIconName = getMenuIconName;
}
